module.exports = __webpack_public_path__ + "img/xls.c59fb1bc.png";